import { PAGINATION_LIMIT } from '@/utils/pagination-constants';

export const getTemplatesListSearchParams = ({
  searchParams,
  initialPage,
}: {
  searchParams: URLSearchParams;
  initialPage?: number;
}) => {
  const getPage = () => {
    if (initialPage) {
      return initialPage;
    }
    // else we should use the search params
    const pageStr = searchParams.get('page') || '1';
    let _page = isNaN(Number(pageStr)) ? 1 : parseInt(pageStr, 10);

    _page = _page < 1 ? 1 : _page;

    return _page;
  };

  const getOffset = () => {
    let offset = (getPage() - 1) * PAGINATION_LIMIT;
    if (offset < 0) {
      offset = 0;
    }
    return offset;
  };

  const getDesignParam = () => decodeURIComponent(searchParams.get('design') || '');

  const getCategoriesParam = () => decodeURIComponent(searchParams.get('categories') || '');

  const getSearchQuery = () => {
    const search = searchParams.get('search') || '';
    return decodeURIComponent(search.trim());
  };

  const getGroupParam = () => {
    const group = searchParams.get('group') || '';
    return decodeURIComponent(group.trim());
  };

  const getFavoritesParam = () => {
    const favorites = searchParams.get('favorites') || '';
    return decodeURIComponent(favorites.trim());
  };

  const getRecentParams = () => {
    const recent = searchParams.get('recent') || '';
    return decodeURIComponent(recent.trim());
  };

  return {
    page: getPage(),
    offset: getOffset(),
    designParam: getDesignParam(),
    categoriesParam: getCategoriesParam(),
    searchQuery: getSearchQuery(),
    groupParam: getGroupParam(),
    favoritesParam: getFavoritesParam(),
    recentParam: getRecentParams(),
  };
};
